module.exports = __webpack_public_path__ + "static/media/avatar.37cdda93.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatar.png
// module id = 33
// module chunks = 0